import axios from 'axios';
import {actions as notifActions} from 'redux-notifications';
import actions from './../actions';
import {getMessage} from './i18n';
import {postLogin} from './postLoginLogout';

const isValidString = (input) => (typeof (input) === 'string' && input.length);

const isFunction = (fn) => (!!(fn && typeof (fn) === 'function'));

Object.assign(axios.defaults, {
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'x-request-source': 'ui'
    },
    timeout: 90000,
    withCredentials: true,
    xsrfHeaderName: 'X-XSRF-TOKEN',
    xsrfCookieName: 'XSRF-TOKEN',
    validateStatus: (status) => ((status >= 200 && status < 300) || status === 304)
});

const getErrorMessage = (response) => {
    response = response || {};
    const defaultMessage = {
        400: getMessage('error.badRequest'),
        401: getMessage('error.unauthorized'),
        403: getMessage('error.forbidden'),
        404: getMessage('error.notFound'),
        500: getMessage('error.internalServerError')
    }[response.status];
    if (isValidString(response.data)) {
        return response.data;
    } else if (typeof (response.data) === 'object') {
        if (isValidString(response.data.message)) {
            return response.data.message;
        } else if (response.data.success === false) {
            let {reason, reasonMsgKey, msgArguments = []} = response.data;
            if (isValidString(reasonMsgKey) && getMessage(reasonMsgKey, msgArguments) !== reasonMsgKey) {
                return getMessage(reasonMsgKey, msgArguments);
            } else if (isValidString(reason)) {
                return reason;
            } else {
                return defaultMessage;
            }
        }
    }
    return defaultMessage;
};

const responseInterceptorMiddleware = store => {
    axios.interceptors.response.use(
        response => (response.data),
        error => {
            let errorMessage = getErrorMessage(error.response || {}) || error.message || '';
            if ((error.response || {}).status === 401) {
                if (((error.response || {}).config || {}).redirectUnauthorized) {
                    postLogin();
                } else {
                    errorMessage && store.dispatch(actions.boConfirm(errorMessage, postLogin));
                }
            } else {
                !axios.isCancel(error) && errorMessage && store.dispatch(notifActions.notifSend({
                    kind: 'danger',
                    message: errorMessage
                }));
            }
            return Promise.reject(error);
        }
    );
    return next => action => (next(action));
};

const boFetch = (options) => (axios({
    url: options.url,
    method: options.method || 'get',
    params: options.params || {},
    ...(options.headers ? {headers: options.headers} : {}),
    ...(!options.method || options.method === 'get' ? {} : {data: options.data}),
    ...(('redirectUnauthorized' in options) ? {redirectUnauthorized: options.redirectUnauthorized} : {}),
    ...(isFunction(options.paramsSerializer) ? {paramsSerializer: options.paramsSerializer} : {}),
    ...(isFunction(options.cancelToken) ? {cancelToken: new axios.CancelToken(options.cancelToken)} : {})
}));

export {boFetch as default, responseInterceptorMiddleware, getErrorMessage};


// WEBPACK FOOTER //
// ./src/app/utils/request.js